import React from 'react'
import { Button, Header, Image, Modal, Grid, Icon } from 'semantic-ui-react'
import ReactTable from "react-table";
import "react-table/react-table.css"
import { CSVDownload, CSVLink } from "react-csv";




class ProductAnalyticsModal extends React.Component {

    constructor() {
        super()
    }


    renderTableHeader() {
        const { inventory_details_data } = this.props
        const tempArr = [];
        if (inventory_details_data.header) {
            for (var i = 0; i < inventory_details_data.header.length; i++) {
                tempArr.push({
                    Header: inventory_details_data.header[i],
                    accessor: inventory_details_data.keys[i],
                    Cell: props => <span style={{ width: 80 }}>{props.value}</span> // Custom cell components!

                })
            }
        }
        return tempArr;

    }
    renderTableData() {
        const { inventory_details_data } = this.props
        const tempArr = [];
        if (inventory_details_data.data) {
            for (var i = 0; i < inventory_details_data.data.length; i++) {
                let obj = inventory_details_data.data[i]
                let tempObj = {}
                for (var key in obj) {
                    // tempObj[key] = obj[key]
                    if (typeof (obj[key]) === 'number') {
                        if (Math.round(obj[key]) == obj[key]) {
                            // console.log('Int number')
                            tempObj[key] = obj[key]
                        }
                        else {
                            // console.log('float number')
                            tempObj[key] = obj[key].toFixed(2)
                        }
                    }
                    else {
                        tempObj[key] = obj[key] === true ? JSON.stringify(obj[key]) : obj[key]
                    }

                    // tempObj[key] = obj[key]
                }
                tempArr.push(tempObj)
            }
        }
        return tempArr;
    }

    render() {
        let { showModal, inventory_details_data } = this.props;

        const csvData = () => {
            let temp = [];
            let data;
            let inventory_details_data_data = inventory_details_data.data || [];
            let inventory_details_data_keys = inventory_details_data.keys || [];

            const tempArr = [];
            if (inventory_details_data.data) {
                for (var i = 0; i < inventory_details_data.data.length; i++) {
                    let obj = inventory_details_data.data[i]
                    let tempObj = {}
                    for (var key in obj) {
                        if (typeof (obj[key]) === 'number') {
                            if (Math.round(obj[key]) == obj[key]) {
                                tempObj[key] = obj[key]
                            }
                            else {
                                tempObj[key] = obj[key].toFixed(2)
                            }
                        }
                        else {
                            tempObj[key] = obj[key] === true ? JSON.stringify(obj[key]) : obj[key]
                        }
                    }
                    tempArr.push(tempObj)
                }
            }

            return tempArr;
        };

        return (
            <Modal
                centered={true}
                open={showModal}
                basic
                dimmer={'blurring'}
                size={'large'}
                animation={'fade'}
                style={styles.modalContainer}
            >
                <Modal.Content>
                    <Grid columns={1} >
                        <Grid.Column style={styles.mainColumn} >
                            <Grid.Row style={styles.headingRow}>
                                <div style={styles.closeIconDiv}>
                                    <Icon
                                        name={"close"}
                                        type="font-awesome"
                                        color={"#666874"}
                                        style={styles.closeIcon}
                                        onClick={() => this.props.hideProductDetailsModal()}
                                    />
                                    
                                </div>
                                <div style={styles.inventoryHeading}>
                                    Inventory details
                                </div>
                                <CSVLink
                                    filename={'Product-Inventory.csv'}
                                    headers={inventory_details_data.keys}
                                    data={csvData()}
                                >
                                    <Button style={styles.downloadBtn} >
                                        Download
                            </Button>
                                </CSVLink>
                            </Grid.Row>
                            <Grid.Row style={styles.tableRow} >
                                <ReactTable
                                    data={this.renderTableData()}
                                    columns={this.renderTableHeader()}
                                    showPageJump={false}
                                    showPageSizeOptions= {false}
                                    showPagination={true}
                                    defaultPageSize={7}
                                    // pageSizeOptions={[7, 10, 20, 25, 50, 100]}
                                    // filterable={this.state.showSearch}
                                    defaultFilterMethod={(filter, row, column) => {
                                        const id = filter.pivotId || filter.id
                                        return row[id] !== undefined ?
                                            RegExp("\\b" + filter.value, "i").test(String(row[id])) : true
                                    }}
                                    resizable={true}
                                    className="tabelMain ui sortable celled tableNewCont"
                                />
                            </Grid.Row>
                        </Grid.Column>
                    </Grid>

                </Modal.Content>
            </Modal>
        )
    }
}

const styles = {
    modalContainer: {
        width: '90%',
        height: '100%',
        marginTop : 0,
        marginLeft : '5%',
    },
    mainColumn: {
        width: '100%',
        padding: 0,
        backgroundColor: '#ffff',
        justifyContent: 'center'
    },
    headingRow: {
        width: '100%',
        height: 80,
        display: 'flex',
        margin: 0,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: "1px solid #d4d4d5",
    },
    closeIconDiv: {
        width: 30,
        marginLeft: 20,
        alignItems: 'center',
        justifyContent: 'center'
    },
    closeIcon: {
        fontSize: 18,
        height: 18,
        alignItems: 'center',
        textAlign: 'center',
        color : "#666874",
    },
    inventoryHeading: {
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 25,
        color: '#666874',
        fontFamily: 'Roboto',
        fontWeight: '500'
    },
    downloadBtn: {
        backgroundColor: '#662d94',
        width: 100,
        color: "#ffff",
        marginRight: 20,
        padding: 5,
        height: 40
    },
    tableRow: {
        // marginTop: '2%',
        width: '100%',
        // backgroundColor: '#f4f4',
        alignItems: 'center',
        marginLeft: 0,
        marginRight: 0,
        marginTop: 20,
        marginBottom: 20,
    }
}




export default ProductAnalyticsModal;



// WEBPACK FOOTER //
// ./src/components/TabSales/productAnalyticsModal.js